import Vue from 'vue'
import axios from 'axios'
const API = {
  data: {
  },
  /**
   * Returns formula as json structure
   * @param id - ID of the component for which the formula is to be evaluated
   * @param type - Type of the component for which the formula is to be evaluated 'kz', 'kb', 'sp, 'rp'
   * @param fnSuccess - optional func is called when request success
   * @param fnError - optional func is called when request failed
  */
  getKennzahlFormel (showValue, id, type, balance, fnSuccess, fnError) {
    var url = Vue.prototype.storage.host() + '/ajaxGetBankData.php'
    Vue.prototype.$api.showIdle()
    let reqData = {
      userID: Vue.prototype.storage.getUserId(),
      type: 'KENNZAHL-FORMEL',
      kfzId: id,
      addValues: showValue,
      kfzType: type,
      balance: Vue.prototype.$api.balanceToString(balance),
      currency: Vue.prototype.storage.getCurrency(),
      currencyDimension: Vue.prototype.storage.getCurrencyDimension(),
    }
    reqData = Vue.prototype.$api.injectRequestData(reqData)
    reqData.balance = Vue.prototype.$api.balanceToString(balance)
    axios({
      method: 'post',
      data: JSON.stringify(reqData),
      url: url,
      responseType: 'json'
    })
      .then(function (response) {
        Vue.prototype.$api.hideIdle()
        if (fnSuccess) {
          if (!response.data.success && response.data.errorMsg) {
            Vue.prototype.$eventHub.$emit('OnShowError', response.data)
          } else {
            fnSuccess(response.data)
          }
        }
      }, function (error) {
        Vue.prototype.$api.hideIdle()
        Vue.prototype.$eventHub.$emit('OnShowError', error)
        if (fnError) {
          fnError(error, status, error)
        } else {
          console.error('error')
          console.error(error)
          console.log(status)
        }
      })
  }
}
export default API



// WEBPACK FOOTER //
// ./src/components/api/kennzahlApi.js